<div class="container mt-3">
    <div class="trip-summary">
        <ul>
            <li *ngIf="allDays.flights.length > 0">
                <div class="icon">
                    <span class="overview-icons">
                        <app-service-icon [icon]="'plane-departure'" [customPath]="getServiceIconPath('plane-departure')"></app-service-icon>
                    </span>
                    <h2 class="title">{{ "SUMMARY.VOLO" | translate }}</h2>
                </div>
                <div class="details">
                    <ul>
                        <ng-container *ngFor="let flight of allDays.flights">
                            <li>
                                <div class="info">
                                    <!-- <p class="ft08">Biglietteria Aerea</p> -->
                                    <!-- <h5>Biglietteria Aerea</h5> -->
                                    <p class="ft019 m-0 dflex-flights">
                                        <span class="departure">
                                            {{ flight.segments[0].departure.airportName }}<br>
                                            <span class="text-capitalize">{{ flight.segments[0].departure.date |
                                                localizedDate: "dd MMM" }} {{ flight.segments[0].departure.hour
                                                }}</span>
                                        </span>
                                        <app-flight-stopover [flight]="flight"></app-flight-stopover>

                                        <span class="arrival">
                                            {{ flight.segments[flight.segments.length - 1].arrival.airportName }}<br>
                                            <span class="text-capitalize">{{ flight.segments[flight.segments.length -
                                                1].arrival.date | localizedDate: "dd MMM" }} {{
                                                flight.segments[flight.segments.length - 1].arrival.hour }}</span>
                                        </span>
                                    </p>

                                    <div class="itinerary-content">
                                        <div class="itinerary-night">
                                            <span class="itinerary-icons"><em class="fas fa-users"></em></span>
                                            <h6>
                                                <span>{{ (flight.adults || 0) + (flight.children || 0) + (flight.infants || 0) }} {{ ((flight.adults || 0) + (flight.children || 0) + (flight.infants || 0)) === 1 ? ('ITINERARY.TRANSPORT.FLIGHT.PASSENGER_SINGULAR' | translate) : ('ITINERARY.TRANSPORT.FLIGHT.PASSENGER_PLURAL' | translate) }}</span>
                                            </h6>
                                        </div>
                                    </div>

                                    <small class="text-default" *ngIf="flight?.notes">
                                        <ng-container *ngFor="let item of flight.notes">
                                            <ng-container *ngIf="state === 'Preventivo'">
                                                <ng-container *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                    <span [innerHTML]="item.text | safeHtml"></span>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngIf="state === 'Confermata'">
                                                <ng-container *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                    <span [innerHTML]="item.text | safeHtml"></span>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </small>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div class="totalFlights" *ngIf="enableAccountBalanceServicePriceDetails">
                    <p>{{amount.totalFlightsService | localizedCurrency: 'EUR': 'symbol'}}</p>
                </div>
            </li>
            <li *ngIf="allDays.hotels.length > 0">
                <div class="icon">
                    <span class="overview-icons">
                        <app-service-icon [icon]="'hotel'" [customPath]="getServiceIconPath('hotel')"></app-service-icon>
                    </span>
                    <h2 class="title">{{ "SUMMARY.SISTEMAZIONI" | translate }}</h2>
                </div>
                <div class="details">
                    <ul>
                        <ng-container *ngFor="let hotel of allDays.hotels">
                            <li>
                                <div class="info">
                                    <h5>
                                        <span class="text-capitalize">
                                            {{ hotel.hotels[0]?.name | lowercase }}
                                        </span>
                                    </h5>

                                    <div class="itinerary-content">
                                        <div class="itinerary-adress">
                                            <span class="itinerary-icons"><em class="fas fa-map-marker-alt"></em></span>
                                            <h6>
                                                <span class="text-capitalize">
                                                    {{ hotel.hotels[0]?.address | lowercase }}
                                                </span>
                                            </h6>
                                        </div>
                                    </div>

                                    <div class="itinerary-content">
                                        <div class="itinerary-night">
                                            <span class="itinerary-icons"><app-service-icon [icon]="'hotel'" [customPath]="getServiceIconPath('hotel')"></app-service-icon></span>
                                            <h6>
                                                <span class="text-capitalize">
                                                    {{ hotel.checkin | localizedDate: "dd MMM" }} -
                                                    {{ hotel.checkout | localizedDate: "dd MMM" }}
                                                </span>
                                            </h6>
                                        </div>
                                        <app-room [rooms]="hotel.hotels[0]?.rooms"></app-room>
                                    </div>
                                    <small class="text-default" *ngIf="hotel?.notes">
                                        <ng-container *ngFor="let item of hotel.notes">
                                            <ng-container *ngIf="state === 'Preventivo'">
                                                <ng-container *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                    <span [innerHTML]="item.text | safeHtml"></span>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngIf="state === 'Confermata'">
                                                <ng-container *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                    <span [innerHTML]="item.text | safeHtml"></span>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </small>
                                </div>
                                <div class="price" *ngIf="enableAccountBalanceServicePriceDetails">
                                    <p class="ft09">{{getTotal(hotel.hotels[0]?.rooms) |
                                        localizedCurrency:"EUR":'symbol'}}</p>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </li>
            <li *ngIf="allDays.cars.length > 0">
                <div class="icon">
                    <span class="overview-icons">
                        <app-service-icon [icon]="'car-side'" [customPath]="getServiceIconPath('car-side')"></app-service-icon>
                    </span>
                    <h2 class="title">{{ "SUMMARY.RENT-A-CAR" | translate }}</h2>
                </div>
                <div class="details">
                    <ul>
                        <ng-container *ngFor="let car of allDays.cars">
                            <li>
                                <div class="info">
                                    <div class="row">

                                        <div class="col-xs-12 col-md-12">
                                            <div class="row">
                                                <div class="col-xs-12 col-md-12">
                                                    <h5>
                                                        <span class="text-capitalize">{{ car.vehicles[0].model |
                                                            lowercase }}</span>
                                                    </h5>
                                                </div>
                                            </div>

                                            <div class="d-flex-icons">

                                                <div class="itinerary-content">
                                                    <span class="itinerary-icons"><em class="fas fa-store"></em></span>
                                                    <h6>
                                                        <span class="text-capitalize">{{car.vehicles[0].vendor?.name |
                                                            lowercase}}
                                                        </span>
                                                    </h6>
                                                </div>

                                                <div class="itinerary-content">
                                                    <span class="itinerary-icons"><em class="fas fa-star"></em></span>
                                                    <h6>
                                                        <span class="text-capitalize">{{car.vehicles[0].carClass |
                                                            lowercase}}</span>
                                                    </h6>
                                                </div>
                                            </div>

                                            <div class="itinerary-content">
                                                <span class="itinerary-icons">
                                                    <em class="fas fa-arrow-right"></em>
                                                </span>
                                                <h6>
                                                    <span class="text-capitalize">
                                                        {{car.pickup?.date + " " + car.pickup?.hour
                                                        | localizedDate: "dd MMM, HH:mm"}}
                                                        -
                                                        {{ car.vehicles[0].locations?.pickup[0]?.name | lowercase }}
                                                    </span>
                                                </h6>
                                            </div>

                                            <div class="itinerary-content">
                                                <span class="itinerary-icons"><em class="fas fa-arrow-left"></em></span>
                                                <h6>
                                                    <span class="text-capitalize">
                                                        {{car.dropoff?.date + " " + car.dropoff?.hour
                                                        | localizedDate: "dd MMM, HH:mm"}}
                                                        -
                                                        {{ car.vehicles[0].locations?.dropoff[0]?.name | lowercase }}
                                                    </span>
                                                </h6>
                                            </div>

                                        </div>
                                    </div>
                                    <small class="text-default" *ngIf="car?.notes">
                                        <ng-container *ngFor="let item of car.notes">
                                            <ng-container *ngIf="state === 'Preventivo'">
                                                <ng-container *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                    <span [innerHTML]="item.text | safeHtml"></span>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngIf="state === 'Confermata'">
                                                <ng-container *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                    <span [innerHTML]="item.text | safeHtml"></span>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </small>
                                </div>
                                <div class="price" *ngIf="enableAccountBalanceServicePriceDetails">
                                    <p class="ft09">{{getTotal(car.vehicles) | localizedCurrency:"EUR":'symbol'}}</p>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </li>
            <li *ngIf="allDays.transfers.length > 0">
                <div class="icon">
                    <span class="overview-icons">
                        <app-service-icon [icon]="'car-side'" [customPath]="getServiceIconPath('car-side')"></app-service-icon>
                    </span>
                    <h2 class="title">{{ "SUMMARY.TRANSPORT" | translate }}</h2>
                </div>
                <div class="details">
                    <ul>
                        <ng-container *ngFor="let transfers of allDays.transfers">
                            <ng-container *ngFor="let transfer of transfers.optionals">
                                <li>
                                    <div class="info">
                                        <div class="row">
                                            <div class="col-xs-12 col-md-8">
                                                <div class="itinerary-content">
                                                    <div>
                                                        <span class="itinerary-icons"><app-service-icon [icon]="'taxi'" [customPath]="getServiceIconPath('taxi')"></app-service-icon></span>
                                                        <h6>
                                                            <span class="text-capitalize">
                                                                <ng-container *ngIf="transfer?.type; else transferName">
                                                                    {{transfer.type?.toLowerCase()}}
                                                                    <span class="subservice--name"
                                                                        *ngIf="!!transfer.items.length"> | <small>{{
                                                                            transfer.items[0]?.name }}</small></span>
                                                                </ng-container>
                                                                <ng-template #transferName>
                                                                    {{transfer?.name}}
                                                                </ng-template>
                                                            </span>
                                                        </h6>
                                                    </div>
                                                    <div>
                                                        <span class="itinerary-icons"><em class="fas fa-users"></em></span>
                                                        <h6>
                                                            <span>{{ (transfer.items[0]?.adults?.totalNumber || 0) + (transfer.items[0]?.children?.totalNumber || 0) }} {{ "COMMON.PERSON_PLURAL" | translate }}</span>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <small class="text-default" *ngIf="transfers?.notes">
                                            <ng-container *ngFor="let item of transfers?.notes">
                                                <ng-container *ngIf="state === 'Preventivo'">
                                                    <ng-container *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                        <span [innerHTML]="item.text | safeHtml"></span>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="state === 'Confermata'">
                                                    <ng-container *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                        <span [innerHTML]="item.text | safeHtml"></span>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </small>
                                    </div>
                                    <div class="price" *ngIf="enableAccountBalanceServicePriceDetails">
                                        <p class="ft09">{{getTotal(transfer.items) | localizedCurrency:"EUR":'symbol'}}
                                        </p>
                                    </div>
                                </li>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="showOptionlServices">
                            <ng-container *ngFor="let transfers of allDays.transfersSuggested">
                                <ng-container *ngFor="let transfer of transfers.optionals">
                                    <li class="transfersSuggested">
                                        <div class="info">
                                            <div class="row">
                                                <div class="col-xs-12 col-md-8">
                                                    <div class="itinerary-content">
                                                        <span class="itinerary-icons"><app-service-icon [icon]="'taxi'" [customPath]="getServiceIconPath('taxi')"></app-service-icon></span>
                                                        <h6>
                                                            <span class="text-capitalize">
                                                                <ng-container *ngIf="transfer?.type; else transferName">
                                                                    ({{ "SUMMARY.ALTERNATIVES" | translate }}):
                                                                    {{transfer.type?.toLowerCase()}}
                                                                    <span class="subservice--name"
                                                                        *ngIf="!!transfer.items.length"> | <small>{{
                                                                            transfer.items[0]?.name }}</small></span>
                                                                </ng-container>
                                                                <ng-template #transferName>
                                                                    ({{ "SUMMARY.ALTERNATIVES" | translate }}):
                                                                    {{transfer?.name}}
                                                                </ng-template>
                                                            </span>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <small class="text-default" *ngIf="transfers?.notes">
                                                <ng-container *ngFor="let item of transfers?.notes">
                                                    <ng-container *ngIf="state === 'Preventivo'">
                                                        <ng-container
                                                            *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                            <span [innerHTML]="item.text | safeHtml"></span>
                                                        </ng-container>
                                                    </ng-container>
                                                    <ng-container *ngIf="state === 'Confermata'">
                                                        <ng-container
                                                            *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                            <span [innerHTML]="item.text | safeHtml"></span>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </small>
                                        </div>
                                        <div class="price" *ngIf="enableAccountBalanceServicePriceDetails">
                                            <p class="ft09">{{getTotal(transfer.items) |
                                                localizedCurrency:"EUR":'symbol'}}</p>
                                        </div>
                                    </li>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ul>
                </div>
            </li>
            <li *ngIf="allDays.escorteds.length > 0">
                <div class="icon">
                    <span class="overview-icons">
                        <app-service-icon [icon]="'bus'" [customPath]="getServiceIconPath('bus')"></app-service-icon>
                    </span>
                    <h2 class="title">{{ "SUMMARY.ESCORTEDS" | translate }}</h2>
                </div>
                <div class="details">
                    <ul>
                        <ng-container *ngFor="let optionals of allDays.escorteds">
                            <ng-container *ngFor="let optional of optionals.optionals">
                                <li>
                                    <div class="info">
                                        <h5>
                                            <span class="text-capitalize">{{optional.type?.toLowerCase()}}</span>
                                        </h5>
                                        <div class="d-flex-icons">
                                            <div class="itinerary-content">
                                                <span class="itinerary-icons"><app-service-icon [icon]="'landmark'" [customPath]="getServiceIconPath('landmark')"></app-service-icon></span>
                                                <h6>
                                                    <span class="text-capitalize">{{ optional.name?.toLowerCase()
                                                        }}</span>
                                                </h6>
                                            </div>
                                            <div class="itinerary-content">
                                                <span class="itinerary-icons"><em
                                                        class="fas fa-map-marker-alt"></em></span>
                                                <h6>
                                                    <span class="text-capitalize">{{ optional?.city_name}}</span>
                                                </h6>
                                            </div>
                                            <div class="itinerary-content">
                                                <span class="itinerary-icons"><em
                                                        class="fas fa-calendar-alt"></em></span>
                                                <h6>
                                                    <span class="text-capitalize">{{ optional?.date | localizedDate:
                                                        "ddMMM" }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="itinerary-content" *ngIf="optional?.items[0]?.name">
                                            <div class="itinerary-night">
                                                <span class="itinerary-icons"><em class="fas fa-bed"></em></span>
                                                <h6>
                                                    <span class="text-capitalize">{{ optional.items[0].name }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="itinerary-content" *ngIf="((optional?.items[0]?.adults?.totalNumber || 0) + (optional?.items[0]?.children?.totalNumber || 0)) || totalPax">
                                            <div class="itinerary-night">
                                                <span class="itinerary-icons"><em class="fas fa-users"></em></span>
                                                <h6>
                                                    <span>{{ (optional?.items[0]?.adults?.totalNumber || 0) + (optional?.items[0]?.children?.totalNumber || 0) || totalPax }} {{ "COMMON.PERSON_PLURAL" | translate }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <small class="text-default" *ngIf="optionals.notes">
                                            <ng-container *ngFor="let item of optionals.notes">
                                                <ng-container *ngIf="state === 'Preventivo'">
                                                    <ng-container *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                        <span [innerHTML]="item.text | safeHtml"></span>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="state === 'Confermata'">
                                                    <ng-container *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                        <span [innerHTML]="item.text | safeHtml"></span>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </small>
                                    </div>
                                    <div class="price" *ngIf="enableAccountBalanceServicePriceDetails">
                                        <p class="ft09">{{getTotal(optional.items) | localizedCurrency:"EUR":'symbol'}}
                                        </p>
                                    </div>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ul>
                </div>
            </li>
            <li *ngIf="allDays.optionals.length > 0">
                <div class="icon">
                    <span class="overview-icons">
                        <app-service-icon [icon]="'landmark'" [customPath]="getServiceIconPath('landmark')"></app-service-icon>
                    </span>
                    <h2 class="title">{{ "SUMMARY.ACTIVITIES" | translate }}</h2>
                </div>
                <div class="details">
                    <!-- <p style="margin: 10px;"><strong>{{ "SUMMARY.NOTE_ACTIVITIES" | translate }}</strong></p> -->
                    <ul>
                        <ng-container *ngFor="let optionals of allDays.optionals">
                            <ng-container *ngFor="let optional of optionals.optionals">
                                <li>
                                    <div class="info">
                                        <h5>
                                            <span class="text-capitalize">{{optional.type?.toLowerCase()}}</span>
                                        </h5>
                                        <div class="d-flex-icons">
                                            <div class="itinerary-content">
                                                <span class="itinerary-icons"><app-service-icon [icon]="'landmark'" [customPath]="getServiceIconPath('landmark')"></app-service-icon></span>
                                                <h6>
                                                    <span class="text-capitalize">{{ optional.name?.toLowerCase()
                                                        }}</span>
                                                </h6>
                                            </div>
                                            <div class="itinerary-content">
                                                <span class="itinerary-icons"><em
                                                        class="fas fa-map-marker-alt"></em></span>
                                                <h6>
                                                    <span class="text-capitalize">{{ optional?.city_name}}</span>
                                                </h6>
                                            </div>
                                            <div class="itinerary-content">
                                                <span class="itinerary-icons"><em
                                                        class="fas fa-calendar-alt"></em></span>
                                                <h6>
                                                    <span class="text-capitalize">{{ optional?.date | localizedDate:
                                                        "ddMMM" }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="itinerary-content">
                                            <div class="itinerary-night">
                                                <span class="itinerary-icons"><em class="fas fa-users"></em></span>
                                                <h6>
                                                    <span>{{ (optional?.items[0].adults?.totalNumber || 0) + (optional?.items[0].children?.totalNumber || 0) }} {{ "COMMON.PERSON_PLURAL" | translate }}</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <small class="text-default" *ngIf="optionals?.notes">
                                            <ng-container *ngFor="let item of optionals.notes">
                                                <ng-container *ngIf="state === 'Preventivo'">
                                                    <ng-container *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                        <span [innerHTML]="item.text | safeHtml"></span>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="state === 'Confermata'">
                                                    <ng-container *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                        <span [innerHTML]="item.text | safeHtml"></span>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </small>
                                    </div>
                                    <div class="price" *ngIf="enableAccountBalanceServicePriceDetails">
                                        <p class="ft09">{{getTotal(optional.items) | localizedCurrency:"EUR":'symbol'}}
                                        </p>
                                    </div>
                                </li>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="showOptionlServices">
                            <ng-container *ngFor="let optionals of allDays.optionalsSuggested">
                                <ng-container *ngFor="let optional of optionals.optionals">
                                    <li class="optionalsSuggested">
                                        <div class="info">
                                            <h5>
                                                <span class="text-capitalize">({{ "SUMMARY.ALTERNATIVES" | translate
                                                    }}): {{optional.type?.toLowerCase()}}</span>
                                            </h5>
                                            <div class="d-flex-icons">
                                                <div class="itinerary-content">
                                                    <span class="itinerary-icons"><app-service-icon [icon]="'landmark'" [customPath]="getServiceIconPath('landmark')"></app-service-icon></span>
                                                    <h6>
                                                        <span class="text-capitalize">{{ optional.name?.toLowerCase()
                                                            }}</span>
                                                    </h6>
                                                </div>
                                                <div class="itinerary-content">
                                                    <span class="itinerary-icons"><em
                                                            class="fas fa-map-marker-alt"></em></span>
                                                    <h6>
                                                        <span class="text-capitalize">{{ optional?.city_name}}</span>
                                                    </h6>
                                                </div>
                                                <div class="itinerary-content">
                                                    <span class="itinerary-icons"><em
                                                            class="fas fa-calendar-alt"></em></span>
                                                    <h6>
                                                        <span class="text-capitalize">{{ optional?.date | localizedDate:
                                                            "dd MMM" }}</span>
                                                    </h6>
                                                </div>
                                            </div>
                                            <div class="itinerary-content">
                                                <div class="itinerary-night">
                                                    <span class="itinerary-icons"><em class="fas fa-users"></em></span>
                                                    <h6>
                                                        <span>{{ (optional?.items[0].adults?.totalNumber || 0) + (optional?.items[0].children?.totalNumber || 0) }} {{ "COMMON.PERSON_PLURAL" | translate }}</span>
                                                    </h6>
                                                </div>
                                            </div>
                                            <small class="text-default" *ngIf="optionals?.notes">
                                                <ng-container *ngFor="let item of optionals.notes">
                                                    <ng-container *ngIf="state === 'Preventivo'">
                                                        <ng-container
                                                            *ngIf="item.id.endsWith('estrattoconto_preventivo')">
                                                            <span [innerHTML]="item.text | safeHtml"></span>
                                                        </ng-container>
                                                    </ng-container>
                                                    <ng-container *ngIf="state === 'Confermata'">
                                                        <ng-container
                                                            *ngIf="item.id.endsWith('estrattoconto_conferma')">
                                                            <span [innerHTML]="item.text | safeHtml"></span>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </small>
                                        </div>
                                        <div class="price" *ngIf="enableAccountBalanceServicePriceDetails">
                                            <p class="ft09">{{getTotal(optional.items) |
                                                localizedCurrency:"EUR":'symbol'}}</p>
                                        </div>
                                    </li>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ul>
                </div>
            </li>
            <li *ngIf="allDays.extra?.fees.length > 0 || allDays.extra?.insurances.length > 0">
                <div class="icon">
                    <span class="overview-icons">
                        <i class="fas fa-plus"></i>
                    </span>
                    <h2 class="title">Extra</h2>
                </div>
                <div class="details">
                    <ul>
                        <ng-container *ngFor="let groupedItem of groupItemsByName(extra.fees)">
                            <li>
                                <div class="info">
                                    <h5>
                                        <span class="text-capitalize">{{groupedItem.name}}</span>
                                    </h5>
                                </div>
                                <div class="price">
                                    x {{groupedItem.count}}
                                    <p *ngIf="enableAccountBalanceServicePriceDetails" class="ft09">
                                        {{groupedItem.totalAmount | localizedCurrency:"EUR":'symbol'}}
                                    </p>
                                </div>
                            </li>
                        </ng-container>

                        <ng-container *ngFor="let groupedItem of groupItemsByName(extra.insurances)">
                            <li>
                                <div class="info">
                                    <h5>
                                        <span class="text-capitalize">{{groupedItem.name}}</span>
                                    </h5>
                                </div>
                                <div class="price">
                                    x {{groupedItem.count}}
                                    <p *ngIf="enableAccountBalanceServicePriceDetails" class="ft09">
                                        {{groupedItem.totalAmount | localizedCurrency:"EUR":'symbol'}}
                                    </p>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </li>
        </ul>
        <ul class="summary-passengers" *ngIf="passengers && passengers.length > 0">
            <li>
                <div class="icon mb-3">
                    <h2 class="title">{{ "SUMMARY.PASSENGERS_TITLE" | translate }}</h2>
                </div>
                <div class="details">
                    <p>{{ "SUMMARY.PASSENGERS_TEXT" | translate }}</p>

                    <ng-container *ngFor="let passenger of passengers; let i = index;">
                        <p><b>{{ "SUMMARY.PASSENGER" | translate }} {{i + 1}}</b><br>{{ passenger.title }} {{
                            passenger.name }} {{ passenger.surname }}</p>
                    </ng-container>
                </div>
            </li>
        </ul>
    </div>

    <div class="trip-quote" *ngIf="!advInformations.hidePriceB2C || advInformations.isTravelAgency">
        <div class="icon justify-content-between">
            <div class="col-9 p-0 d-flex align-items-center">
                <span class="overview-icons">
                    <i class="fa fa-shopping-cart"></i>
                </span>
                <h2 class="title">{{ "SUMMARY.QUOTE-TITOLO" | translate }}</h2>
            </div>
            <div class="button-group" *ngIf="advInformations.isTravelAgency">
                <button (click)="openModal(historyFeeAgencyModal)" class="btn btn-info"><i class="fa fa-history"></i> {{
                    "SUMMARY.FEE-HISTORY" | translate }}</button>
                <label class="ml-3">
                    <input type="checkbox" [(ngModel)]="advInformations.hidePriceB2C"> {{ "SUMMARY.HIDE_PRICE_B2C" |
                    translate }}
                </label>
            </div>
        </div>
        <ng-container *ngIf="'SUMMARY.QUOTE-SOTTOTITOLO' | translate as subtitle">
            <p class="m-0" *ngIf="subtitle !== 'SUMMARY.QUOTE-SOTTOTITOLO'">{{ subtitle }}</p>
        </ng-container>

        <div class="table">
            <ng-container *ngIf="advInformations.isTravelAgency && showOnlyTotalPrice">
                <ng-container *ngIf="combinePriceServices; else separateInputsShowOnly">
                    <div class="tr">
                        <div class="td">{{ "SUMMARY.QUOTE-COMBINED" | translate }}</div>
                        <div class="td text-right">
                            {{
                            (amountApis?.baseTripPrice || 0) +
                            (amountApis?.flightTicketsPrice || 0) +
                            combinedFeeValue +
                            (insuranceSummaryVisible ? 0 : (amountApis?.insurances?.totalPrice || 0)) +
                            (insuranceSummaryVisible ? 0 : (amountApis?.fees?.totalPrice || 0)) +
                            (isFlightTaxInSummaryIncluded ? (amountApis?.flightTaxesPrice || 0) : 0) |
                            localizedCurrency:"EUR":'symbol'
                            }}
                            <ng-container *ngIf="advInformations.isTravelAgency">
                                <br><span class="txtFeeAgency">{{ "SUMMARY.FEE-AGENCY" | translate }}</span>
                                <input type="number" class="iptAdvInformations" [(ngModel)]="combinedFeeValue"
                                    [max]="maxLimitCombined()">
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-template #separateInputsShowOnly>
                    <div class="tr" *ngIf="amountApis.baseTripPrice > 0">
                        <div class="td">{{ "SUMMARY.QUOTE-TERRA" | translate }}</div>
                        <div class="td text-right">
                            <ng-container *ngIf="insuranceSummaryVisible">
                                {{(amountApis?.baseTripPrice || 0) + (advInformations?.feeLandServices || 0) |
                                localizedCurrency:"EUR":'symbol'}}
                            </ng-container>
                            <ng-container *ngIf="!insuranceSummaryVisible">
                                {{(amountApis?.baseTripPrice || 0) + (advInformations?.feeLandServices || 0) +
                                (amountApis?.insurances?.totalPrice || 0) + (amountApis?.fees?.totalPrice || 0) |
                                localizedCurrency:"EUR":'symbol'}}
                            </ng-container>
                            <ng-container *ngIf="advInformations.isTravelAgency">
                                <br><span class="txtFeeAgency">{{ "SUMMARY.FEE-AGENCY" | translate }}</span>
                                <input type="number" class="iptAdvInformations"
                                    [(ngModel)]="advInformations.feeLandServices"
                                    [max]="maxLimit(amountApis.baseTripPrice)" (input)="checkLimit($event)">
                            </ng-container>
                        </div>
                    </div>
                    <div class="tr" *ngIf="allDays.flights.length > 0">
                        <div class="td">
                            <ng-container *ngIf="isFlightTaxInSummaryIncluded; else notIncludedText">
                                {{ "SUMMARY.QUOTE-VOLO" | translate }} + {{ "SUMMARY.QUOTE-TAX" | translate }}
                            </ng-container>
                            <ng-template #notIncludedText>
                                {{ "SUMMARY.QUOTE-VOLO" | translate }}
                            </ng-template>
                        </div>
                        <div class="td text-right">
                            <ng-container *ngIf="isFlightTaxInSummaryIncluded; else notFlightTaxInSummaryIncluded">
                                {{(amountApis?.flightTicketsPrice || 0) + (advInformations?.feeFlight || 0) +
                                (amountApis?.flightTaxesPrice || 0) |
                                localizedCurrency:"EUR":'symbol' }}
                            </ng-container>
                            <ng-template #notFlightTaxInSummaryIncluded>
                                {{(amountApis?.flightTicketsPrice || 0) + (advInformations?.feeFlight || 0) |
                                localizedCurrency:"EUR":'symbol' }}
                            </ng-template>
                            <ng-container *ngIf="advInformations.isTravelAgency">
                                <br><span class="txtFeeAgency">{{ "SUMMARY.FEE-AGENCY" | translate }}</span>
                                <input type="number" class="iptAdvInformations" [(ngModel)]="advInformations.feeFlight"
                                    [max]="maxLimit(amountApis.flightTicketsPrice)" (input)="checkLimit($event)">
                            </ng-container>
                        </div>
                    </div>
                </ng-template>
                <ng-container *ngIf="allDays.flights.length > 0">
                    <div class="tr" *ngIf="!isFlightTaxInSummaryIncluded">
                        <div class="td">{{ "SUMMARY.QUOTE-TAX" | translate }}</div>
                        <div class="td text-right">
                            {{(amountApis?.flightTaxesPrice || 0) + (advInformations?.feeFlightTaxes || 0) |
                            localizedCurrency:"EUR":'symbol' }}
                            <ng-container *ngIf="advInformations.isTravelAgency && setTaxFlightFee">
                                <br><span class="txtFeeAgency">{{ "SUMMARY.FEE-AGENCY" | translate }}</span>
                                <input type="number" class="iptAdvInformations"
                                    [(ngModel)]="advInformations.feeFlightTaxes"
                                    [max]="maxLimit(amountApis.flightTaxesPrice)" (input)="checkLimit($event)">
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="showSummaryDetail">
                    <ng-container *ngFor="let fee of amountApis.fees.list">
                        <div class="tr">
                            <div class="td">{{ fee.name }}</div>
                            <div class="td text-right">{{fee.price | localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngFor="let insurance of amountApis.insurances.list">
                        <div class="tr">
                            <div class="td">{{ insurance.name }}</div>
                            <div class="td text-right">{{insurance.price | localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-container>
                    <div class="tr">
                        <div class="td text-primary">{{ (advInformations.isTravelAgency ? "SUMMARY.QUOTE-PREVENTIVO-ADV" : "SUMMARY.QUOTE-PREVENTIVO") | translate }}</div>
                        <div class="td text-right text-primary">
                            {{
                            (amountApis?.totalPrice || 0) +
                            (advInformations?.feeFlight || 0) +
                            (advInformations?.feeFlightTaxes || 0) +
                            (advInformations?.feeLandServices || 0)
                            | localizedCurrency:"EUR":'symbol'
                            }}
                        </div>
                    </div>
                    <ng-container *ngIf="commissionType === 'net'; else commissionable">
                        <div class="tr">
                            <div class="td">{{ "SUMMARY.COMMISSION-TYPE-NET" | translate }}</div>
                            <div class="td text-right">{{amountApis.commissionOrDiscount |
                                localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-container>
                    <ng-template #commissionable>
                        <div class="tr">
                            <div class="td">{{ "SUMMARY.COMMISSION-TYPE-COM" | translate }}</div>
                            <div class="td text-right">- {{amountApis.commissionOrDiscount |
                                localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-template>
                    <div class="tr" *ngIf="hasWithholdingTax">
                        <div class="td">{{ amountApis?.withholdingTaxLabel }}</div>
                        <div class="td text-right">{{ withholdingTaxAmount | localizedCurrency:"EUR":'symbol' }}</div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!showOnlyTotalPrice">
                <div class="tr" *ngIf="amountApis.baseTripPrice > 0">
                    <div class="td">{{ "SUMMARY.QUOTE-TERRA" | translate }}</div>
                    <div class="td text-right">
                        <ng-container *ngIf="insuranceSummaryVisible">
                            {{amountApis.baseTripPrice + advInformations.feeLandServices |
                            localizedCurrency:"EUR":'symbol'}}
                        </ng-container>
                        <ng-container *ngIf="!insuranceSummaryVisible">
                            {{amountApis.baseTripPrice + advInformations.feeLandServices +
                            amountApis.insurances.totalPrice + amountApis.fees.totalPrice |
                            localizedCurrency:"EUR":'symbol'}}
                        </ng-container>
                        <ng-container *ngIf="advInformations.isTravelAgency">
                            <br><span class="txtFeeAgency">{{ "SUMMARY.FEE-AGENCY" | translate }}</span>
                            <input type="number" class="iptAdvInformations"
                                [(ngModel)]="advInformations.feeLandServices" [max]="maxLimit(amountApis.baseTripPrice)"
                                (input)="checkLimit($event)">
                        </ng-container>
                    </div>
                </div>
                <div class="tr"
                    *ngIf="extra.fees?.length > 0 && insuranceSummaryVisible || extra.insurances?.length > 0 && insuranceSummaryVisible">
                    <div class="td">{{ "SUMMARY.FEE-INSURANCE" | translate }}</div>
                    <div class="td text-right">{{amountApis.insurances.totalPrice + amountApis.fees.totalPrice |
                        localizedCurrency:"EUR":'symbol' }}</div>
                </div>
                <ng-container *ngIf="allDays.flights.length > 0">
                    <div class="tr">
                        <div class="td">
                            <ng-container *ngIf="isFlightTaxInSummaryIncluded; else notIncludedText">
                                {{ "SUMMARY.QUOTE-VOLO" | translate }} + {{ "SUMMARY.QUOTE-TAX" | translate }}
                            </ng-container>
                            <ng-template #notIncludedText>
                                {{ "SUMMARY.QUOTE-VOLO" | translate }}
                            </ng-template>
                        </div>
                        <div class="td text-right">
                            <ng-container *ngIf="isFlightTaxInSummaryIncluded; else notFlightTaxInSummaryIncluded">
                                {{amountApis?.flightTicketsPrice + advInformations?.feeFlight +
                                amountApis?.flightTaxesPrice
                                |
                                localizedCurrency:"EUR":'symbol' }}
                            </ng-container>
                            <ng-template #notFlightTaxInSummaryIncluded>
                                {{amountApis?.flightTicketsPrice + advInformations?.feeFlight |
                                localizedCurrency:"EUR":'symbol' }}
                            </ng-template>
                            <ng-container *ngIf="advInformations.isTravelAgency">
                                <br><span class="txtFeeAgency">{{ "SUMMARY.FEE-AGENCY" | translate }}</span>
                                <input type="number" class="iptAdvInformations" [(ngModel)]="advInformations.feeFlight"
                                    [max]="maxLimit(amountApis.flightTicketsPrice)" (input)="checkLimit($event)">
                            </ng-container>
                        </div>
                    </div>
                    <div class="tr" *ngIf="!isFlightTaxInSummaryIncluded">
                        <div class="td">{{ "SUMMARY.QUOTE-TAX" | translate }}</div>
                        <div class="td text-right">
                            {{(amountApis?.flightTaxesPrice || 0) + (advInformations?.feeFlightTaxes || 0) |
                            localizedCurrency:"EUR":'symbol' }}
                            <ng-container *ngIf="advInformations.isTravelAgency">
                                <br><span class="txtFeeAgency">{{ "SUMMARY.FEE-AGENCY" | translate }}</span>
                                <input type="number" class="iptAdvInformations"
                                    [(ngModel)]="advInformations.feeFlightTaxes"
                                    [max]="maxLimit(amountApis.flightTaxesPrice)" (input)="checkLimit($event)">
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="showSummaryDetail">
                    <ng-container *ngFor="let fee of amountApis.fees.list">
                        <div class="tr">
                            <div class="td">{{ fee.name }}</div>
                            <div class="td text-right">{{fee.price | localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngFor="let insurance of amountApis.insurances.list">
                        <div class="tr">
                            <div class="td">{{ insurance.name }}</div>
                            <div class="td text-right">{{insurance.price | localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-container>
                    <div class="tr">
                        <div class="td text-primary">{{ (advInformations.isTravelAgency ? "SUMMARY.QUOTE-PREVENTIVO-ADV" : "SUMMARY.QUOTE-PREVENTIVO") | translate }}</div>
                        <div class="td text-right text-primary">
                            {{
                            (amountApis?.totalPrice || 0) +
                            (allDays.flights.length > 0 ? (advInformations?.feeFlight || 0) : 0) +
                            (allDays.flights.length > 0 ? (advInformations?.feeFlightTaxes || 0) : 0) +
                            (advInformations?.feeLandServices || 0)
                            | localizedCurrency:"EUR":'symbol'
                            }}
                        </div>
                    </div>
                    <ng-container *ngIf="commissionType === 'net'; else commissionable">
                        <div class="tr">
                            <div class="td">{{ "SUMMARY.COMMISSION-TYPE-NET" | translate }}</div>
                            <div class="td text-right">{{amountApis.commissionOrDiscount |
                                localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-container>
                    <ng-template #commissionable>
                        <div class="tr">
                            <div class="td">{{ "SUMMARY.COMMISSION-TYPE-COM" | translate }}</div>
                            <div class="td text-right">{{amountApis.commissionOrDiscount |
                                localizedCurrency:"EUR":'symbol' }}</div>
                        </div>
                    </ng-template>
                    <div class="tr" *ngIf="hasWithholdingTax">
                        <div class="td">{{ amountApis?.withholdingTaxLabel }}</div>
                        <div class="td text-right">{{ withholdingTaxAmount | localizedCurrency:"EUR":'symbol' }}</div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- <div class="tr" *ngIf="consolidator === 'USAT'">
                <div class="td">{{ "SUMMARY.ACTIVITIES-TOTALE" | translate }}</div>
                <div class="td text-right">
                    {{ amount.totalActivities | localizedCurrency:"EUR":'symbol' }}
                </div>
            </div> -->
            <div class="tr" *ngIf="showOptionlServices">
                <ng-container *ngIf="amount.optionalsSuggestedTotal || amount.transfersSuggestedTotal">
                    <div class="td">{{ "SUMMARY.OPTION-SERVICES" | translate }}</div>
                    <div class="td text-right">
                        {{ ((amount.optionalsSuggestedTotal || 0) + (amount.transfersSuggestedTotal || 0)) |
                        localizedCurrency:"EUR":'symbol' }}
                    </div>
                </ng-container>
            </div>
            <!-- <div class="tr" *ngIf="showOptionlServices">
                <ng-container *ngIf="amount.transfersSuggestedTotal">
                    <div class="td">{{ "SUMMARY.TRANSFER-SERVICES" | translate }}</div>
                    <div class="td text-right">
                        {{ amount.transfersSuggestedTotal | localizedCurrency:"EUR":'symbol' }}
                    </div>
                </ng-container>
            </div> -->
            <div class="tr">
                <div class="td">{{ (advInformations.isTravelAgency ? "SUMMARY.TOTAL-ADV" : "SUMMARY.QUOTE-TOTALE") | translate }}</div>
                <div class="td text-right">
                    <ng-container *ngIf="advInformations.isTravelAgency">
                        <ng-container *ngIf="showSummaryDetail; else noSummaryDetail">
                            {{ ((amountApis?.totalPrice || 0) +
                            (withholdingTaxAmount || 0)) -
                            (amountApis?.commissionOrDiscount || 0) | localizedCurrency:"EUR":'symbol' }}
                        </ng-container>
                        <ng-template #noSummaryDetail>
                            {{ (amountApis?.totalPrice || 0) + (allDays.flights.length > 0 ? (advInformations?.feeFlight
                            || 0) : 0) +
                            (allDays.flights.length > 0 ? (advInformations?.feeFlightTaxes || 0) : 0) +
                            (advInformations?.feeLandServices || 0) |
                            localizedCurrency:"EUR":'symbol' }}
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="!advInformations.isTravelAgency">
                        {{ (amountApis?.totalPrice || 0) + (allDays.flights.length > 0 ? (advInformations?.feeFlight ||
                        0) : 0) +
                        (allDays.flights.length > 0 ? (advInformations?.feeFlightTaxes || 0) : 0) +
                        (advInformations?.feeLandServices || 0) |
                        localizedCurrency:"EUR":'symbol' }}
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="pr-2 pl-2 pb-2" *ngIf="advInformations.footerText !== '' || advInformations.isTravelAgency">
            <ng-container *ngIf="advInformations.footerText !== ''">
                {{ "HOME.NOTES" | translate }}
            </ng-container>
            <ng-container *ngIf="!advInformations.isTravelAgency && advInformations.footerText !== ''">
                <div class="f-size-12 pt-2" style="white-space: pre-wrap;">
                    {{advInformations.footerText}}
                </div>
            </ng-container>
            <textarea *ngIf="advInformations.isTravelAgency" [(ngModel)]="advInformations.footerText"
                style="width: 100%; height: 130px; font-size: 14px;"></textarea>
        </div>
        <ng-container *ngIf="advInformations.isTravelAgency">
            <div class="text-right p-2" style="position: relative; z-index: 2;">
                <button class="btn btn-primary" (click)="setCustomerOutputAdvInformations()">{{ "SUMMARY.UPDATE-FEE" |
                    translate }}</button>
            </div>
        </ng-container>


    </div>

    <ng-template #historyFeeAgencyModal let-modal>
        <div class="modal-header">
            <h5 class="modal-title">{{ "SUMMARY.FEE-HISTORY-TITLE" | translate }}</h5>
            <button type="button" class="close" (click)="modal.dismiss()">
                &times;
            </button>
        </div>

        <div class="modal-body">
            <div class="container-fluid">
                <div class="row">

                    <div class="table table-history">
                        <div class="tr">
                            <div class="td">{{ "SUMMARY.FEE-HISTORY-CREATE" | translate }}</div>
                            <div class="td">{{ "SUMMARY.FEE-HISTORY-CHANGED" | translate }}</div>
                            <div class="td">Fee flight</div>
                            <div class="td">Fee land</div>
                            <div class="td">Note</div>
                            <div class="td">{{ "SUMMARY.FEE-HISTORY-PRICE" | translate }}</div>
                        </div>
                        <ng-container *ngFor="let history of uniqueHistory">
                        <div class="tr"
                            [class]="history.deleted ? 'tr inactive' : 'tr active'">
                            <div class="td">{{history.created}}</div>
                            <div class="td">{{history.changed}}</div>
                            <div class="td">{{(history.feeFlight || 0) | localizedCurrency:"EUR":'symbol'}}</div>
                            <div class="td">{{(history.feeLandServices || 0) | localizedCurrency:"EUR":'symbol'}}</div>
                            <div class="td">{{history.footerText}}</div>
                            <div class="td">
                                <span [ngStyle]="history.hidePriceB2C
                                    ? {'background-color': '#dc3545', 'color': '#fff', 'border-radius': '4px', 'padding': '2px 8px', 'font-size': '12px'}
                                    : {'background-color': '#28a745', 'color': '#fff', 'border-radius': '4px', 'padding': '2px 8px', 'font-size': '12px'}">
                                    {{ history.hidePriceB2C ? ("SUMMARY.FEE-HISTORY-HIDDEN" | translate) : ("SUMMARY.FEE-HISTORY-VISIBLE" | translate) }}
                                </span>
                            </div>
                        </div>
                        </ng-container>
                        <div class="tr" *ngIf="!advInformations.history || advInformations.history.length === 0">
                            <div class="td" colspan="6" style="text-align: center; font-style: italic; color: #666;">Non
                                sono presenti dati storici</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </ng-template>

</div>